import { useField } from 'remix-validated-form'
import Combo, { ComboProps } from '../Combo'
import FormInputWrapper, { FormInputWrapperProps } from './FormInputWrapper'
import { OptionType } from 'types/OptionType'

type FormComboboxProps = Omit<FormInputWrapperProps<any>, `onChange`> & ComboProps & { labelClassName: string }
/**
 * Combobox that receives options from props
 * @summary IMPORTANT: the input value will be the entire option object, so the validation schema that parses this input needs to refine the value like this:
 *
 * `comboVal: z.object({ value: z.string(), id: z.string(), name: z.string() }).transform((option) => option.value)`
 * @param {FormComboboxProps} props
 */
export default function FormCombo({
  name,
  label,
  cols,
  wrapperClassName,
  labelClassName,
  inputClassName,
  newLineError,
  onChange,
  ...props
}: Omit<FormComboboxProps, `value`> & { value: OptionType | undefined }) {
  const { error, setTouched } = useField(name, {
    validationBehavior: { initial: `onSubmit`, whenTouched: `onSubmit`, whenSubmitted: `onSubmit` },
  })
  const changeHandler = (option: OptionType) => {
    setTouched(true)
    // setValue(options)
    onChange?.(option)
  }
  return (
    <>
      <FormInputWrapper
        {...{
          name,
          label,
          error,
          newLineError,
          cols,
          wrapperClassName,
          className: labelClassName,
          infoTooltip: props.infoTooltip,
        }}
      >
        <Combo {...props} name={name} inputClassName={inputClassName} onChange={changeHandler} />
      </FormInputWrapper>
    </>
  )
}
